import { useMutation } from '@tanstack/react-query';

const useVoWifiActivationMutation = (services: any) => {
  return useMutation({
    mutationKey: ['vowifi_activation'],
    mutationFn: services.voWifiActivation as (
      params: Record<string, any>,
    ) => Promise<Record<string, any>>,
  });
};

export default useVoWifiActivationMutation;
